var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobTabIconPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1636 13.4269L14.6856 7.63979C13.8465 5.67645 12.3027 5.59729 11.2656 7.46562L9.76939 10.1652C9.00939 11.5348 7.59231 11.6535 6.61064 10.4265L6.43648 10.2048C5.41523 8.92229 3.97439 9.08062 3.23814 10.5452L1.87648 13.2765C0.918559 15.1765 2.30398 17.4169 4.42564 17.4169H14.5273C16.5856 17.4169 17.9711 15.319 17.1636 13.4269Z",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51807 6.3335C6.82974 6.3335 7.89307 5.27017 7.89307 3.9585C7.89307 2.64682 6.82974 1.5835 5.51807 1.5835C4.20639 1.5835 3.14307 2.64682 3.14307 3.9585C3.14307 5.27017 4.20639 6.3335 5.51807 6.3335Z",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobTabIconPhoto);
export default __webpack_public_path__ + "static/media/create_job_tab_icon_photo.7423e0a299a8d70794b8a39e25aaf787.svg";
export { ForwardRef as ReactComponent };